// extracted by mini-css-extract-plugin
export var privacyPolicePage = "privacyPolicy-module--privacyPolicePage--IG+4Z";
export var wrapper = "privacyPolicy-module--wrapper--KvAnx";
export var inner = "privacyPolicy-module--inner--rteV+";
export var cookieSettingsBtn = "privacyPolicy-module--cookieSettingsBtn--ovTLB";